import SignUpForm from "./SignUp/SignUpForm";
import Laser247Logo from "../../assets/images/brand/title.png";
import LoginPageBanner from "../../assets/login_page_banner.webp";
import { useNavigate } from "react-router-dom";
import { LOGIN_ROUTE } from "@hypexone/uicore";
import { IoArrowBack } from "react-icons/io5";
import { domain } from "../../constants/Branding";
import { getEnvVariable } from "../../constants/brandConfig";

const SignUpPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-full min-h-screen bg-goldenYellow">
      {/* Header: same as login — banner, logo, back top-left */}
      <header
        className="relative flex flex-col items-center justify-center h-[36vh] pt-12 pb-8 px-4 shrink-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${LoginPageBanner})` }}
      >
        <button
          type="button"
          onClick={() => navigate(LOGIN_ROUTE)}
          className="absolute top-3 left-3 w-9 h-9 rounded-full bg-black flex items-center justify-center p-2 hover:opacity-90"
          aria-label="Back"
        >
          <IoArrowBack className="text-white text-xl" />
        </button>
        <img src={getEnvVariable(domain, "logo")} alt="logo" className="h-[110px] object-contain" />
      </header>

      {/* Main content: golden yellow */}
      <main className="flex-1 px-6 py-3 md:py-6 md:mt-4">
        <SignUpForm />
      </main>

      {/* Bottom bar */}
      <div className="h-1.5 w-full bg-black shrink-0" />
    </div>
  );
};

export default SignUpPage;
